import assign from 'lodash/assign';
import constants from '../constants';
import Filter from 'app/shared/models/Filter';

const initState = new Filter();

const filter = (state = initState, action = {}) => {
  const { type, payload } = action;

  if (type === constants.UPDATE_FILTER) {
    return assign({}, state, payload);
  }
  return state;
};

export default filter;
